import React from "react";

export function SectionLoader({ loader }) {
  return (
    <>
      {loader && (
        <div id="section-loader" className="loader_box">
          <div className="loader-circle"></div>
        </div>
      )}
    </>
  );
}
